export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Get In Touch</h2>
        <p className="text-gray-300 text-lg mb-16">
          Have questions about our products? We're here to help you.
        </p>

        <div className="space-y-8 text-left max-w-xl mx-auto">
          <div className="flex items-start gap-4">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-map-pin-line text-white text-xl"></i>
            </div>
            <div>
              <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Address</p>
              <p className="text-white text-base font-medium">Vjekoslava Klaica 26</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-building-line text-white text-xl"></i>
            </div>
            <div>
              <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">City</p>
              <p className="text-white text-base font-medium">Slavonski Brod</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-mail-line text-white text-xl"></i>
            </div>
            <div>
              <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Postal Code</p>
              <p className="text-white text-base font-medium">35000</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-earth-line text-white text-xl"></i>
            </div>
            <div>
              <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Country</p>
              <p className="text-white text-base font-medium">Croatia</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-mail-send-line text-white text-xl"></i>
            </div>
            <div>
              <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Email</p>
              <p className="text-white text-base font-medium">info@ritmodoo.com</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-phone-line text-white text-xl"></i>
            </div>
            <div>
              <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Phone</p>
              <p className="text-white text-base font-medium">+1 9379891230</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}